// Numbers
export const [
  DEFAULT_LICENSE_REQUEST_RETRIES,
  DEFAULT_LICENSE_REQUEST_TIMEOUT,
  MS_TO_WAIT_ON_RECONNECTION_DEFAULT,
  MS_TO_WAIT_ON_RECONNECTION_WEBOS,
  MS_TO_WAIT_ON_RECONNECTION_TIZEN,
  MS_TO_WAIT_ON_RECONNECTION_HISENSE,
  MS_TO_WAIT_ON_RECONNECTION_ZEASN,
  MS_TO_WAIT_ON_RECONNECTION_FIRETV,
  MS_TO_WAIT_ON_RECONNECTION_TITAN,
  MS_TO_WAIT_ON_RECONNECTION_VEGAOS,
  PLAYER_REQUEST_TIMEOUT,
  PLAYER_REQUEST_STALL_TIMEOUT,
  PLAYER_REQUEST_CONNECTION_TIMEOUT,
  PLAYER_REQUEST_MAX_ATTEMPTS,
  PLAYER_REQUEST_BASE_DELAY,
  PLAYER_REQUEST_BACKOFF_FACTOR,
  PLAYER_REQUEST_FUZZ_FACTOR,
  LL_BUFFER_BACKWARD,
  LL_BUFFER_FORWARD,
  LL_TARGET_LATENCY,
  LL_CATCHUP_PLAYBACK_RATE,
  LL_CATCHUP_PLAYBACK_RATE_THRESHOLD,
  LL_CATCHUP_SEEK_THRESHOLD,
  LL_FALLBACK_PLAYBACK_RATE,
  LL_FALLBACK_PLAYBACK_RATE_THRESHOLD,
  LL_FALLBACK_SEEK_THRESHOLD,
  LIVE_REBUFFERING_GOAL,
  VOD_REBUFFERING_GOAL,
  DATADOG_SAMPLE_RATE,
  DATADOG_REPLAY_SAMPLE_RATE,
  PLAYER_HEARTBEAT_TIME_MINUTES,
  MINUTES_BEFORE_TOKEN_REFRESH,
  MAX_FETCH_ATTEMPTS,
  RETRY_DELAY_MS,
  timesPressedBackButtonOnPdp,
  WANT_TO_LEAVE_COUNT_BACK,
  PLAYER_FETCH_SCHEDULES_RETRY_SECONDS,
  PLAYER_FETCH_SCHEDULES_RETRY_COUNT,
  PLAYER_FAKE_SCHEDULE_DEFAULT_DURATION_MINUTES,
  PLAYER_LONG_PAUSE_GO_TO_LIVE_DURATION_MINUTES,
  channelMinimumSizeToFetch,
  newEPGOffsetStartMinutes,
  channelsPageSize,
  schedulesNumberEpg,
  schedulesMaxChannels,
] = [
  import.meta.env.VITE_DEFAULT_LICENSE_REQUEST_RETRIES,
  import.meta.env.VITE_DEFAULT_LICENSE_REQUEST_TIMEOUT,
  import.meta.env.VITE_MS_TO_WAIT_ON_RECONNECTION_DEFAULT,
  import.meta.env.VITE_MS_TO_WAIT_ON_RECONNECTION_WEBOS,
  import.meta.env.VITE_MS_TO_WAIT_ON_RECONNECTION_TIZEN,
  import.meta.env.VITE_MS_TO_WAIT_ON_RECONNECTION_HISENSE,
  import.meta.env.VITE_MS_TO_WAIT_ON_RECONNECTION_ZEASN,
  import.meta.env.VITE_MS_TO_WAIT_ON_RECONNECTION_FIRETV,
  import.meta.env.VITE_MS_TO_WAIT_ON_RECONNECTION_TITAN,
  import.meta.env.VITE_MS_TO_WAIT_ON_RECONNECTION_VEGAOS,
  import.meta.env.VITE_PLAYER_REQUEST_TIMEOUT,
  import.meta.env.VITE_PLAYER_REQUEST_STALL_TIMEOUT,
  import.meta.env.VITE_PLAYER_REQUEST_CONNECTION_TIMEOUT,
  import.meta.env.VITE_PLAYER_REQUEST_MAX_ATTEMPTS,
  import.meta.env.VITE_PLAYER_REQUEST_BASE_DELAY,
  import.meta.env.VITE_PLAYER_REQUEST_BACKOFF_FACTOR,
  import.meta.env.VITE_PLAYER_REQUEST_FUZZ_FACTOR,
  import.meta.env.VITE_LL_BUFFER_BACKWARD,
  import.meta.env.VITE_LL_BUFFER_FORWARD,
  import.meta.env.VITE_LL_TARGET_LATENCY,
  import.meta.env.VITE_LL_CATCHUP_PLAYBACK_RATE,
  import.meta.env.VITE_LL_CATCHUP_PLAYBACK_RATE_THRESHOLD,
  import.meta.env.VITE_LL_CATCHUP_SEEK_THRESHOLD,
  import.meta.env.VITE_LL_FALLBACK_PLAYBACK_RATE,
  import.meta.env.VITE_LL_FALLBACK_PLAYBACK_RATE_THRESHOLD,
  import.meta.env.VITE_LL_FALLBACK_SEEK_THRESHOLD,
  import.meta.env.VITE_LIVE_REBUFFERING_GOAL,
  import.meta.env.VITE_VOD_REBUFFERING_GOAL,
  import.meta.env.VITE_DATADOG_SAMPLE_RATE,
  import.meta.env.VITE_DATADOG_REPLAY_SAMPLE_RATE,
  import.meta.env.VITE_PLAYER_HEARTBEAT_TIME_MINUTES,
  import.meta.env.VITE_MINUTES_BEFORE_TOKEN_REFRESH,
  import.meta.env.VITE_MAX_FETCH_ATTEMPTS,
  import.meta.env.VITE_RETRY_DELAY_MS,
  import.meta.env.VITE_TIMES_PRESSED_BACK_BUTTON_ON_PDP,
  import.meta.env.VITE_WANT_TO_LEAVE_COUNT_BACK,
  import.meta.env.VITE_PLAYER_FETCH_SCHEDULES_RETRY_SECONDS,
  import.meta.env.VITE_PLAYER_FETCH_SCHEDULES_RETRY_COUNT,
  import.meta.env.VITE_PLAYER_FAKE_SCHEDULE_DEFAULT_DURATION_MINUTES,
  import.meta.env.VITE_PLAYER_LONG_PAUSE_GO_TO_LIVE_DURATION_MINUTES,
  import.meta.env.VITE_CHANNEL_MINIMUM_SIZE_TO_FETCH,
  import.meta.env.VITE_NEW_EPG_OFFSET_START_MINUTES,
  import.meta.env.VITE_NEW_EPG_CHANNELS_PAGE_SIZE,
  import.meta.env.VITE_NEW_EPG_SCHEDULES_NUMBER,
  import.meta.env.VITE_NEW_EPG_SCHEDULES_MAX_CHANNELS,
].map(parseNumber);

// Booleans
export const [
  BITMOVIN_ANALYTICS_ENABLED,
  IS_MY_LIST_ENABLED,
  USE_LOW_LATENCY_STREAMS,
  LL_CATCH_UP_ACTIVE,
  TOOLBOX_IS_TEST_REFRESH_TOKEN,
  IS_FIRST_WARNING_DGO_SKYMAIS_ACTIVE,
  IS_SECOND_WARNING_DGO_SKYMAIS_ACTIVE,
  IS_GRAN_HERMANO_WARNING_ACTIVE,
  IS_UPSELL_MESSAGES_ACTIVE,
  IS_UPSELL_GRAN_HERMANO_ACTIVE,
  USE_STREAMING_V4,
  IS_UPSELL_BANNER_GRAN_HERMANO_ACTIVE,
  MQTT_FLAG,
  MQTT_REALTIME_ENTITLEMENT_FLAG,
  isMqttAuthV2Active,
  IS_UPSELL_PAY_PER_VIEW_ACTIVE,
  IS_TAPPP_SDK_MODAL_ACTIVE,
  IS_TAPPP_SDK_ACTIVE,
  GET_USER_CUSTOM_DATA,
  SET_USER_CUSTOM_DATA,
  NEW_TERMS_API,
  USE_LAYOUT_PAGES_V4,
  IS_CURABLE_BANNER_ACTIVE,
  isSpideoMoreLikeThisActive,
  TAPPP_USE_GUIDEID,
  isLearnActionV4Active,
  isPagesV5Active,
  isCustomSkinActive,
  isUpSellMsoMessageActive,
  backButtonWantToLeaveActive,
  isMyPageActive,
  isLoginFlowCreateAccountActive,
  isProgramCompletionActive,
  isLogsNpawActive,
  useLearnActionClick,
  useCarouselV5,
  isNewEPGActive,
  isSportsNewEPGActive,
  NPAW_P2P_ACTIVE,
  IS_PAL_SDK_ACTIVE,
  NPAW_CDN_SELECTOR_ACTIVE,
  ITGisActive,
  logsITGActive,
  IS_KEY_MOMENTS_ACTIVE,
  IS_KEY_MOMENTS_NOTIFICATION_DOT_ACTIVE,
  IS_KEY_MOMENTS_ONBOARDING_ACTIVE,
  tapppXSportsSdkActive,
  isRowAdsBannerActive,
  isLanderBannerActive,
  isToastBannerActive,
  isNewEpgAllStationsFilterVisible,
  USE_LL_EXTENDED_SEEK,
  IS_PLAYER_DIAGNOSTICS_ACTIVE,
  IS_LEGO_PLAYER_ACTIVE,
  IS_LEGO_PLAYER_FORCE_ACTIVE,
  IS_LEGO_PLAYER_LOADING_ANIMATION_ACTIVE,
  IS_LEGO_PLAYER_MINI_EPG_ACTIVE,
  IS_LEGO_PLAYER_SUBTITLES_ACTIVE,
] = [
  import.meta.env.VITE_BITMOVIN_ANALYTICS_ENABLED,
  import.meta.env.VITE_IS_MY_LIST_ENABLED,
  import.meta.env.VITE_USE_LOW_LATENCY_STREAMS,
  import.meta.env.VITE_LL_CATCH_UP_ACTIVE,
  import.meta.env.VITE_TOOLBOX_IS_TEST_REFRESH_TOKEN,
  import.meta.env.VITE_IS_FIRST_WARNING_DGO_SKYMAIS_ACTIVE,
  import.meta.env.VITE_IS_SECOND_WARNING_DGO_SKYMAIS_ACTIVE,
  import.meta.env.VITE_IS_GRAN_HERMANO_WARNING_ACTIVE,
  import.meta.env.VITE_IS_UPSELL_MESSAGES_ACTIVE,
  import.meta.env.VITE_IS_UPSELL_GRAN_HERMANO_ACTIVE,
  import.meta.env.VITE_USE_STREAMING_V4,
  import.meta.env.VITE_IS_UPSELL_BANNER_GRAN_HERMANO_ACTIVE,
  import.meta.env.VITE_MQTT,
  import.meta.env.VITE_MQTT_REALTIME_ENTITLEMENT_FLAG,
  import.meta.env.VITE_IS_MQTT_AUTH_V2_ACTIVE,
  import.meta.env.VITE_IS_UPSELL_PAY_PER_VIEW_ACTIVE,
  import.meta.env.VITE_IS_TAPPP_SDK_MODAL_ACTIVE,
  import.meta.env.VITE_IS_TAPPP_SDK_ACTIVE,
  import.meta.env.VITE_GET_USER_CUSTOM_DATA,
  import.meta.env.VITE_SET_USER_CUSTOM_DATA,
  import.meta.env.VITE_NEW_TERMS_API,
  import.meta.env.VITE_USE_LAYOUT_PAGES_V4,
  import.meta.env.VITE_IS_CURABLE_BANNER_ACTIVE,
  import.meta.env.VITE_IS_SPIDEO_MORE_LIKE_THIS_ACTIVE,
  import.meta.env.VITE_TAPPP_USE_GUIDEID,
  import.meta.env.VITE_IS_LEARN_ACTION_V4_ACTIVE,
  import.meta.env.VITE_IS_PAGES_V5_ACTIVE,
  import.meta.env.VITE_WONDERWALL_FEATURE_FLAG,
  import.meta.env.VITE_IS_UPSELL_MSO_MESSAGE_ACTIVE,
  import.meta.env.VITE_WANT_TO_LEAVE_ACTIVE,
  import.meta.env.VITE_IS_MY_PAGE_ACTIVE,
  import.meta.env.VITE_IS_LOGIN_FLOW_CREATE_ACCOUNT_ACTIVE,
  import.meta.env.VITE_IS_PROGRAM_COMPLETION_ACTIVE,
  import.meta.env.VITE_NPAW_LOGS_ACTIVE,
  import.meta.env.VITE_USE_LEARN_ACTION_CLICK,
  import.meta.env.VITE_USE_CAROUSEL_V5,
  import.meta.env.VITE_IS_NEW_EPG_ACTIVE,
  import.meta.env.VITE_IS_SPORTS_NEW_EPG_ACTIVE,
  import.meta.env.VITE_NPAW_P2P_ACTIVE,
  import.meta.env.VITE_IS_PAL_SDK_ACTIVE,
  import.meta.env.VITE_NPAW_CDN_SELECTOR_ACTIVE,
  import.meta.env.VITE_ENABLE_ITG,
  import.meta.env.VITE_ENABLE_ITG_LOGS,
  import.meta.env.VITE_IS_KEY_MOMENTS_ACTIVE,
  import.meta.env.VITE_IS_KEY_MOMENTS_NOTIFICATION_DOT_ACTIVE,
  import.meta.env.VITE_IS_KEY_MOMENTS_ONBOARDING_ACTIVE,
  import.meta.env.VITE_IS_TAPPP_XSPORTS_SDK_ACTIVE,
  import.meta.env.VITE_IS_ROW_ADS_ACTIVE,
  import.meta.env.VITE_IS_LANDER_BANNER_ACTIVE,
  import.meta.env.VITE_IS_TOAST_BANNER_ACTIVE,
  import.meta.env.VITE_NEW_EPG_SHOW_ALL_STATIONS_FILTER,
  import.meta.env.VITE_USE_LL_EXTENDED_SEEK,
  import.meta.env.VITE_IS_PLAYER_DIAGNOSTICS_ACTIVE,
  import.meta.env.VITE_LEGO_PLAYER_ACTIVE,
  import.meta.env.VITE_LEGO_PLAYER_FORCE_ACTIVE,
  import.meta.env.VITE_LEGO_PLAYER_LOADING_ANIMATION_ACTIVE,
  import.meta.env.VITE_LEGO_PLAYER_MINI_EPG_ACTIVE,
  import.meta.env.VITE_LEGO_PLAYER_SUBTITLES_ACTIVE,
].map(parseBoolean);

// Strings
export const [
  APP_VERSION = '0.0.0-local',
  GA_TRACKING_ID_EVENTS,
  GA_TRACKING_ID_ERROR,
  BACKEND_SERVICE_HOST,
  WEB_URL,
  AUTH_SERVICE_HOST,
  AUTH_CLIENT_ID,
  PAGE_PROFILE,
  PAGE_HOME,
  PAGE_VOD,
  PAGE_SPORTS,
  PAGE_LIVE,
  PAGE_LIVE_NEW_EPG,
  PAGE_KIDS,
  pageMyPage,
  PAGE_PRESEARCH,
  BITMOVIN_ANALYTICS_KEY,
  BETA_APP_URL,
  DEFAULT_COUNTRY,
  PLAYER_CONFIG_URL,
  DATADOG_APPLICATION_ID,
  DATADOG_CLIENT_TOKEN,
  DATADOG_SERVICE,
  ENVIRONMENT,
  APP_THEME,
  OTT_SSLA_BASE_URL,
  OTT_DTH_TVE_SSLA_BASE_URL,
  SKYMAIS_BASE_URL,
  UPSELL_URL_OTT_DTH_TVE_SSLA,
  UPSELL_URL_OTT_BRASIL,
  UPSELL_URL_DTH_TVE_BRASIL,
  TAPPP_SDK_URL,
  UPSELL_PAY_PER_VIEW_START_DATE,
  UPSELL_PAY_PER_VIEW_END_DATE,
  UPSELL_PAY_PER_VIEW_URL,
  UPSELL_PAY_PER_VIEW_TITLE,
  UPSELL_PAY_PER_VIEW_DESCRIPTION,
  UPSELL_PAY_PER_VIEW_LOGO_URL,
  UPSELL_PAY_PER_VIEW_BACKGROUND_URL,
  UPSELL_PAY_PER_VIEW_CAMPAIGN_NAME,
  TAPPP_ENV,
  moreLikeThisVodTitle,
  moreLikeThisEpgTitle,
  TOOLBOX_URL,
  TOOLBOX_OPEN_AM_KEY,
  TOOLBOX_HOST,
  titanUrlDGO,
  titanUrlSkymais,
  regionAppSupport,
  createAccountUrlSSLA,
  createAccountUrlBR,
  zeasnUrlDGO,
  zeasnUrlSkymais,
  deviceITG,
  accountIdITG,
] = [
  import.meta.env.VITE_VERSION,
  import.meta.env.VITE_GA_TRACKING_ID_EVENTS,
  import.meta.env.VITE_GA_TRACKING_ID_ERROR,
  import.meta.env.VITE_BACKEND_SERVICE_HOST,
  import.meta.env.VITE_WEB_URL,
  import.meta.env.VITE_AUTH_SERVICE_HOST,
  import.meta.env.VITE_AUTH_CLIENT_ID,
  import.meta.env.VITE_PAGE_PROFILE,
  import.meta.env.VITE_PAGE_HOME,
  import.meta.env.VITE_PAGE_VOD,
  import.meta.env.VITE_PAGE_SPORTS,
  import.meta.env.VITE_PAGE_LIVE,
  import.meta.env.VITE_PAGE_LIVE_NEW_EPG,
  import.meta.env.VITE_PAGE_KIDS,
  import.meta.env.VITE_PAGE_MY_PAGE,
  import.meta.env.VITE_PAGE_PRESEARCH,
  import.meta.env.VITE_BITMOVIN_ANALYTICS_KEY,
  import.meta.env.VITE_BETA_APP_URL,
  import.meta.env.VITE_DEFAULT_COUNTRY,
  import.meta.env.VITE_PLAYER_CONFIG_URL,
  import.meta.env.VITE_DATADOG_APPLICATION_ID,
  import.meta.env.VITE_DATADOG_CLIENT_TOKEN,
  import.meta.env.VITE_DATADOG_SERVICE,
  import.meta.env.VITE_ENVIRONMENT,
  import.meta.env.VITE_THEME,
  import.meta.env.VITE_OTT_SSLA_BASE_URL,
  import.meta.env.VITE_OTT_DTH_TVE_SSLA_BASE_URL,
  import.meta.env.VITE_SKYMAIS_BASE_URL,
  import.meta.env.VITE_UPSELL_URL_OTT_DTH_TVE_SSLA,
  import.meta.env.VITE_UPSELL_URL_OTT_BRASIL,
  import.meta.env.VITE_UPSELL_URL_DTH_TVE_BRASIL,
  import.meta.env.VITE_TAPPP_SDK_URL,
  import.meta.env.VITE_UPSELL_PAY_PER_VIEW_START_DATE,
  import.meta.env.VITE_UPSELL_PAY_PER_VIEW_END_DATE,
  import.meta.env.VITE_UPSELL_PAY_PER_VIEW_URL,
  import.meta.env.VITE_UPSELL_PAY_PER_VIEW_TITLE,
  import.meta.env.VITE_UPSELL_PAY_PER_VIEW_DESCRIPTION,
  import.meta.env.VITE_UPSELL_PAY_PER_VIEW_LOGO_URL,
  import.meta.env.VITE_UPSELL_PAY_PER_VIEW_BACKGROUND_URL,
  import.meta.env.VITE_UPSELL_PAY_PER_VIEW_CAMPAIGN_NAME,
  import.meta.env.VITE_TAPPP_ENV,
  import.meta.env.VITE_MORE_LIKE_THIS_VOD_TITLE,
  import.meta.env.VITE_MORE_LIKE_THIS_EPG_TITLE,
  import.meta.env.VITE_TOOLBOX_URL,
  import.meta.env.VITE_TOOLBOX_OPEN_AM_KEY,
  import.meta.env.VITE_TOOLBOX_HOST,
  import.meta.env.VITE_TITAN_URL_DGO,
  import.meta.env.VITE_TITAN_URL_SKYMAIS,
  import.meta.env.VITE_REGION_APP,
  import.meta.env.VITE_CREATE_ACCOUNT_URL_SSLA,
  import.meta.env.VITE_CREATE_ACCOUNT_URL_BR,
  import.meta.env.VITE_ZEASN_URL_DGO,
  import.meta.env.VITE_ZEASN_URL_SKYMAIS,
  import.meta.env.VITE_ITG_DEVICE,
  import.meta.env.VITE_ITG_ACCOUNT_ID,
];

export const [
  PARENTAL_CONTROL_COUNTRIES,
  GRAN_HERMANO_COUNTRIES,
  UPSELL_PAY_PER_VIEW_CHANNELS,
  UPSELL_PAY_PER_VIEW_COUNTRIES,
  TAPPP_SDK_COUNTRIES,
  tapppBetsCountries,
  TAPPP_ALLOWED_USERS,
  newEPGAllowedUsers,
  NEW_TERMS_COUNTRIES,
  SHOW_LOG_IN_ENVIRONMENTS,
  titanOsTvModels,
  notOsRegionApp,
  loginFlowCreateAccountCountries,
  showInfosSettingEnvironments,
  tapppXSportsChannelsUnsupported,
  tapppAutoOpenCategories,
  LL_EXTENDED_SEEK_CHANNELS,
  OLE_CDN_URL_COMPARISON,
  LEGO_PLAYER_CHANNELS,
] = [
  import.meta.env.VITE_PARENTAL_CONTROL_COUNTRIES,
  import.meta.env.VITE_GRAN_HERMANO_COUNTRIES,
  import.meta.env.VITE_UPSELL_PAY_PER_VIEW_CHANNELS,
  import.meta.env.VITE_UPSELL_PAY_PER_VIEW_COUNTRIES,
  import.meta.env.VITE_TAPPP_SDK_COUNTRIES,
  import.meta.env.VITE_TAPPP_BETS_COUNTRIES,
  import.meta.env.VITE_TAPPP_ALLOWED_USERS,
  import.meta.env.VITE_NEW_EPG_ALLOWED_USERS,
  import.meta.env.VITE_NEW_TERMS_COUNTRIES,
  import.meta.env.VITE_SHOW_LOG_IN_ENVIRONMENTS,
  import.meta.env.VITE_TITAN_OS_TV_MODELS,
  import.meta.env.VITE_OS_NOT_REGION_APP,
  import.meta.env.VITE_LOGIN_FLOW_CREATE_ACCOUNT_COUNTRIES,
  import.meta.env.VITE_SHOW_INFOS_SETTING_ENVIRONMENTS,
  import.meta.env.VITE_TAPPP_XSPORTS_CHANNELS_UNSUPPORTED,
  import.meta.env.VITE_TAPPP_AUTO_OPEN_CATEGORIES,
  import.meta.env.VITE_LL_EXTENDED_SEEK_CHANNELS,
  import.meta.env.VITE_IS_OLE_CDN_URL_COMPARISON,
  import.meta.env.VITE_LEGO_PLAYER_CHANNELS,
].map(parseCSVSet);

export const [
  TAPPP_UNSUPPORTED_OS_VERSIONS,
  newEPGUnsupportedOSVersions,
  IS_LOW_END_DEVICE,
  IS_LOW_END_DEVICE_LEGO,
  playerConfigOverrideRules,
  lowLatencyConfigOverride,
  PLAYER_RESOLUTION_OVERRIDES,
  legoPlayerConfigOverride,
] = [
  import.meta.env.VITE_TAPPP_UNSUPPORTED_OS_VERSIONS,
  import.meta.env.VITE_NEW_EPG_UNSUPPORTED_OS_VERSIONS,
  import.meta.env.VITE_IS_LOW_END_DEVICE,
  import.meta.env.VITE_IS_LOW_END_DEVICE_LEGO,
  import.meta.env.VITE_PLAYER_CONFIG_OVERRIDE,
  import.meta.env.VITE_LOW_LATENCY_CONFIG_OVERRIDE,
  import.meta.env.VITE_PLAYER_RESOLUTION_OVERRIDES,
  import.meta.env.VITE_LEGO_PLAYER_CONFIG_OVERRIDE,
].map(parseJSON);

function parseNumber(value) {
  const parsed = Number.parseFloat(value);

  // eslint-disable-next-line unicorn/no-useless-undefined -- conflicts with consistent-return
  if (Number.isNaN(parsed)) return undefined;

  return parsed;
}

function parseBoolean(value) {
  if (value === undefined || value === null) return false;
  return String(value).trim().toLowerCase() === 'true';
}

function parseCSV(value) {
  return value?.split(',') || [];
}

function parseCSVSet(value) {
  return new Set(parseCSV(value));
}

function parseJSON(value) {
  let parsedValue;
  try {
    parsedValue = JSON.parse(value);
  } catch (error) {
    console.error('[env] Failed to parse JSON env var:', value, error);
    parsedValue = {};
  }
  return parsedValue;
}
